import React, { FC, useEffect, useRef, useState } from "react";
import { Button, Image, Table, Upload, Tooltip, message, notification, Modal } from "antd";
import { YhBox } from "@/components/YhBox";
import { globalPrompt } from "@/components/message";
import { ColumnsType } from "antd/es/table";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { RouterParamType } from "@/model/navModel";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { IDetailList } from "../../purchaseEnquiryType"
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { ISelectOption } from "@/components/YhFormBox/Types";
import { IVRMshelfDetail, IVRMshelfSearch } from "@/views/base/warehouse/warehouseTypes";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
import { formatNum, formatIntPoint, bigNumber, momentFormat } from "@/utils/utils";
import { DetailType } from "@/types/ScmEnums";
import { importPropsConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhBut } from "@/components/YhButton";
import { purchasePoService } from "@/views/purchase/po/purchasePoService";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import { IPurchaseOfferFields } from "@/views/purchase/offer/purchaseOfferType";
import { SnippetsOutlined } from "@ant-design/icons";
import { getBaseImgLookUrl } from "@/utils/constants";
import { fileDownload } from "@/utils/exportFile";

export const TableBoxSupplier: FC<RouterParamType> = ({ id, mode }) => {
    const {
        detailAddList,
        detailDataSource,
        detailLookList,
        detaiAddDataRowKeys,
        detailDataRowKeys,
        detailEditForm,
        detailLookForm,
        detailAddForm,
        setDetaiAddDataRow,
        setDetailAddList,
        setDetaiAddDataRowKeys,
        setDetailDataRowKeys,
        setDetailDataRow,
        setAddModalVisible,
        setDetailDataSource,
        detailDetailList,
        downloadTpl,
        modelScreenMethod,
        setHistoryVisible,
        setHistoryRow,
        setTopButsControl,
        detailSupplierList
    } = usePurchaseEnquiryDetailsModel();
    const [loading, setLoading] = useState<boolean>(false)
    // 打开附件弹框
    const onPreview = (item: any) => {
        //console.log("附件预览", item);
        let fileMd5 = item?.supplierMd5
        let fileName = item?.supplierFileName as string
        let fileType = item?.contractType as string
        const type = (fileMd5 as string).split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif', 'pdf'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(fileMd5)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        }
        else {
            fileDownload(getBaseImgLookUrl((fileMd5 as string)), fileName)
        }

    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_ENQUIRY_EXPORTSUPPLIER}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => setAddModalVisible(true)}
            >导出</Button>
        </YhAuth>
    </>;

    const defaultColumns: ColumnsType<IPurchaseOfferFields> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '供应商名称',
            width: 120,
            dataIndex: 'supplierName',
        }, {
            title: '总报价',
            width: 150,
            dataIndex: 'amount',
        }, {
            title: '报价时间',
            width: 80,
            dataIndex: 'submitTime',
            render: (t, r) => t ? momentFormat(t) : null
        }, {
            title: '报价截止时间',
            width: 130,
            dataIndex: 'endTime',
            render: (t, r) => t ? momentFormat(t) : null
        }, {
            title: '供应商备注',
            width: 130,
            dataIndex: 'supplierNote',
        }, {
            title: '操作',
            width: 170,
            fixed: "right",
            align: "center",
            dataIndex: 'supplierFileName',
            render: (t, r) =>
                r.supplierMd5 ?
                    <span style={{ position: "relative", cursor: "pointer", color: "#5200ff" }} onClick={() => onPreview(r)}>
                        查看附件
                        <i style={{ position: "absolute", right: "-15px", top: "-3px", color: "#5200ff" }}><SnippetsOutlined /></i>
                    </span> : ""
        }
    ];


    return (
        <>
            {/* {action} */}
            <Table
                style={{ marginTop: 10 }}
                bordered
                loading={{ tip: "数据查询中...", spinning: loading }}
                rowKey={(record: any) => record.id as string}
                columns={defaultColumns}
                dataSource={detailSupplierList}
                pagination={false}
                scroll={{ x: 'max-content', y: 500 }}
            /></>
    )
}